import Errors from './Errors'
import axios from 'axios'
import objectToFormData from '@/src/utils/object-to-form-data'
import deepCopy from '../utils/deep-copy'

export default class Form {
  constructor(data) {
    this.originalData = data

    for (const field in data) {
      this[field] = data[field]
    }

    this.errors = new Errors()
  }

  data() {
    const data = {}

    for (const property in this.originalData) {
      data[property] = this[property]
    }
    return data
  }

  reset() {
    Object.keys(this)
      .filter((key) => !Form.ignore.includes(key))
      .forEach((key) => {
        this[key] = deepCopy(this.originalData[key])
      })
  }

  post(url, type) {
    return this.submit('post', url, type)
  }

  put(url, type) {
    return this.submit('put', url, type)
  }

  patch(url, type) {
    return this.submit('patch', url, type)
  }

  delete(url, type) {
    return this.submit('delete', url, type)
  }

  submit(requestType, url, type, options) {
    let data
    if (type && type === 'form-data') {
      data = objectToFormData(this.removeEmptyFromData())
    } else {
      data = this.removeEmptyFromData()
    }

    return new Promise((resolve, reject) => {
      axios[requestType](
        url,
        data,
        options
          ? {
              ...options,
            }
          : null
      )
        .then((response) => {
          this.onSuccess(response.data)

          resolve(response.data)
        })
        .catch((error) => {
          this.onFail(error.response.data)

          reject(error.response.data)
        })
    })
  }

  onSuccess(data) {
    this.reset()
  }

  onFail(errors) {
    this.errors.record(errors)
  }

  dataToFormData(data) {
    const formData = new FormData()

    for (const key in data) {
      formData.append(key, data[key])
    }

    return formData
  }

  removeEmptyStringFromData() {
    const result = {}
    const data = this.data()
    for (const field in data) {
      if (data[field] === '' && !Form.blanks.includes(field)) {
        result[field] = null
      } else if (data[field] === null && Form.blanks.includes(field)) {
        continue
      } else {
        result[field] = data[field]
      }
    }
    return result
  }

  removeEmptyFromData() {
    const result = {}
    const data = this.data()
    for (const field in data) {
      if (data[field] !== null && data[field] !== '') {
        result[field] = data[field]
      }
    }
    return result
  }
}
Form.ignore = ['busy', 'successful', 'errors', 'originalData']
Form.blanks = ['note']
